export const getUserInfoError = ({ userInfo }) => userInfo.error;
export const getUserInfoMessage = ({ userInfo }) => userInfo.message;
export const getUserInformation = ({ userInfo }) => userInfo.userInfo;
